const PLACEHOLDER_COST_IN_USD = ' - ';

export const computeCostInUsd = (selectedCreditOption, creditValues) => {
  const selectedCreditValue = creditValues.find((creditValue) => creditValue.credit === selectedCreditOption);

  if (!!selectedCreditValue) {
    return selectedCreditValue.currencyValue.toLocaleString();
  }

  return PLACEHOLDER_COST_IN_USD;
};

export const getAmountOfCreditsAfterSuccessfulTransfer = (amount) => {
  const numericalValueOfAmount = parseInt(amount, 0);

  let amountOfCredits;

  // eslint-disable-next-line no-restricted-globals
  if (isNaN(numericalValueOfAmount)) {
    amountOfCredits = 0;
  } else {
    amountOfCredits = numericalValueOfAmount;
  }

  return amountOfCredits.toLocaleString();
};
